/**
 * @file Left sidebar containing only the diagram tree.
 */

import '../css/general.css';
import { useReducerProps } from './App';
import DiagramTree from './DiagramTree';

const LeftSidebar: React.FC<useReducerProps> = ({ state, dispatch }) => {
  return (
    <div className="left-sidebar">
      <DiagramTree state={state} dispatch={dispatch} />
    </div>
  );
};

export default LeftSidebar;
